var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ConnaitreEquipe"},[_c('HeadPage',{attrs:{"title":"L'Équipe","category":"Nous connaitre","img":null,"imgAlt":null}}),_c('div',{staticClass:"ConnaitreEquipe-Content"},[_c('div',{staticClass:"ConnaitreEquipe-Content-Container"},[_c('Card',{attrs:{"img":{
              color: 'nous-connaitre/collaborateurs/GV_Sourire.png',
              black: 'nous-connaitre/collaborateurs/GV_Serieux.png'
            },"name":'Vigné',"firstname":'Gilles',"job":'Président Fondateur',"text":'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla a massa sed turpis consequat sollicitudin et eu lectus.',"socials":[
                      {
                          src: 'global/social/twitter.svg',
                          href: '#',
                          alt: 'Icon Twitter',
                          disabled: true
                      },
                      {
                          src: 'global/social/linkedin.svg',
                          href: 'https://www.linkedin.com/company/jobstreamsas/',
                          alt: 'Icon Linkedin',
                          disabled: false
                      },
                      {
                          src: 'global/social/facebook.svg',
                          href: '#',
                          alt: 'Icon Facebook',
                          disabled: true
                      }
                      ]}}),_c('Card',{attrs:{"img":{
              color: 'nous-connaitre/collaborateurs/PP_Sourire.png',
              black: 'nous-connaitre/collaborateurs/PP_Serieux.png'
            },"name":'Philippe',"firstname":'Pascal',"job":'Directeur JobStream',"text":'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla a massa sed turpis consequat sollicitudin et eu lectus.',"socials":[
                      {
                          src: 'global/social/twitter.svg',
                          href: '#',
                          alt: 'Icon Twitter',
                          disabled: true
                      },
                      {
                          src: 'global/social/linkedin.svg',
                          href: 'https://www.linkedin.com/company/jobstreamsas/',
                          alt: 'Icon Linkedin',
                          disabled: false
                      },
                      {
                          src: 'global/social/facebook.svg',
                          href: '#',
                          alt: 'Icon Facebook',
                          disabled: true
                      }
                      ]}}),_c('Card',{attrs:{"img":{
              color: 'nous-connaitre/collaborateurs/JPB_Sourire.png',
              black: 'nous-connaitre/collaborateurs/JPB_Serieux.png'
            },"name":'Bourdon',"firstname":'Jean-Philippe',"job":'Gérant du Groupe IP',"text":'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla a massa sed turpis consequat sollicitudin et eu lectus.',"socials":[
                      {
                          src: 'global/social/twitter.svg',
                          href: '#',
                          alt: 'Icon Twitter',
                          disabled: true
                      },
                      {
                          src: 'global/social/linkedin.svg',
                          href: 'https://www.linkedin.com/company/jobstreamsas/',
                          alt: 'Icon Linkedin',
                          disabled: false
                      },
                      {
                          src: 'global/social/facebook.svg',
                          href: '#',
                          alt: 'Icon Facebook',
                          disabled: true
                      }
                      ]}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }